import React, { useEffect, useState } from "react";
import { BiSolidDownArrow, BiSolidUpArrow } from "react-icons/bi";
import { FaLock, FaLockOpen } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import ButtonComponent from "../../../../../../app/common-components/ButtonComponent";
import CustomModal from "../../../../../../app/common-components/CustomModal";
import DiscardChanges from "../../../../../../app/common-components/DiscardChanges";
import Input from "../../../../../../app/common-components/form/input";
import Spinners from "../../../../../../app/common-components/Spinner";
import { useCommonAlert } from "../../../../../../app/utilities/helpers";
import {
  AccordianDel,
  AccordianDelDisable,
  AccordianEdit,
  AccordianEditDisable,
} from "../../../../../../assets/images";
import {
  deleteJiracategory,
  getConfigJiraIssueTypeList,
  getConfigJiraPriorityList,
  getConfigJiraStatusList,
  getJiraIssueTypeSave,
  getJiraPrioritySave,
  getJiraStatusSave,
} from "../../ToolsSlice";
import "./styles.css";
import {
  ACTIVE_TAB_VALUES,
  CATEGORY_TYPES,
} from "./Utilities/Identifiers";

// Badge component (Handles both types of badges)
const Badge = ({ text, variant = "default", onRemove, showRemove }) => {
  return (
    <span className={`costomBadge ${variant}`}>
      {text}
      {showRemove && (
        <button className="close-btn" onClick={() => onRemove(text)}>
          ✖
        </button>
      )}
    </span>
  );
};

const CategorizedContainer = ({
  title,
  itemCount,
  isDeletable,
  data,
  activeTab,
  order,
}) => {
  const {
    IssueTypeCatagorizedData,
    PriorityCatagorizedData,
    StatusCatagorizedData,
  } = useSelector((state) => state.toolsApi);

  const getCategorizedData = () => {
    if (activeTab === ACTIVE_TAB_VALUES.ISSUE_TYPE) {
      return IssueTypeCatagorizedData;
    }
    if (activeTab === ACTIVE_TAB_VALUES.PRIORITY) {
      return PriorityCatagorizedData;
    }
    if (activeTab === ACTIVE_TAB_VALUES.STATUS) {
      return StatusCatagorizedData;
    }
    return [];
  };

  const CatagorizedData = getCategorizedData();

  const isUserAddedCategory = (categoryTitle) => {
    if (!Array.isArray(CatagorizedData)) {
      return false;
    }

    // Find the category by title
    const category = CatagorizedData.find(
      (cat) => cat?.categoryName?.toLowerCase() === categoryTitle?.toLowerCase()
    );

    if (!category) {
      return false;
    }

    // User-added categories have configurationtype: "CUSTOM"
    // System/Manual categories have configurationtype: "MANUAL"
    return category.configurationtype === "CUSTOM";
  };

  const [state, setState] = useState({
    discardopen: false,
  });
  const [isOpen, setIsOpen] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isDeleteMode, setIsDeleteMode] = useState(false);
  const [badgeData, setBadgeData] = useState(data);
  const [showModal, setShowModal] = useState(false);
  const [showCategoryDeleteModal, setShowCategoryDeleteModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [originalTitle, setOriginalTitle] = useState(title);
  const [originalOrder, setOriginalOrder] = useState(order?.toString() || "");
  const [originalBadgeData, setOriginalBadgeData] = useState(data);
  const [tempBadgeData, setTempBadgeData] = useState([]);

  const [editedTitle, setEditedTitle] = useState(title);
  const [updatedSortNumvalue, setUpdateSortNumvalue] = useState(
    order?.toString() || ""
  );
  const [saveLoading, setSaveLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const handleEditClick = () => {
    setIsEditMode(true);
    setEditedTitle(title);
    setUpdateSortNumvalue(originalOrder);
    setTempBadgeData([...badgeData]); // clone current badges
  };

  useEffect(() => {
    setUpdateSortNumvalue(
      order !== null && order !== undefined ? order.toString() : ""
    );
  }, [order]);

  const apiListData = () => {
    if (activeTab === ACTIVE_TAB_VALUES.ISSUE_TYPE) {
      dispatch(getConfigJiraIssueTypeList());
    } else if (activeTab === ACTIVE_TAB_VALUES.PRIORITY) {
      dispatch(getConfigJiraPriorityList());
    } else if (activeTab === ACTIVE_TAB_VALUES.STATUS) {
      dispatch(getConfigJiraStatusList());
    }
  };

  // Get the count of categorized items (excluding Uncategorized)
  const sortingOrderLength = Array.isArray(CatagorizedData)
    ? CatagorizedData.filter((item) => item.categoryName !== CATEGORY_TYPES.UNCATEGORIZED)
        .length
    : 0;

  const dispatch = useDispatch();

  const handleRemoveClick = (item) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  const { callCommonAlert, hideCommonAlert } = useCommonAlert();

  const cancelRemove = () => {
    setShowModal(false);
    setSelectedItem(null);
  };
  const cancelDelete = () => {
    setShowCategoryDeleteModal(false);
    setIsDeleteMode(false);
    // setSelectedItem(null);
  };

  const hasChanges = //for checking is any updation is happened
    editedTitle.trim() !== originalTitle.trim() ||
    updatedSortNumvalue !== originalOrder ||
    JSON.stringify(tempBadgeData) !== JSON.stringify(originalBadgeData);

  const saveForUpdating = () => {
    setSaveLoading(true);
    setBadgeData(tempBadgeData);

    // Find the current category from categorized data to get configId
    const currentCategory = Array.isArray(CatagorizedData)
      ? CatagorizedData.find((cat) => cat.categoryName === originalTitle)
      : null;

    const configId = currentCategory?.configId || null;

    // Extract IDs from tempBadgeData based on activeTab
    let itemIds;
    if (activeTab === ACTIVE_TAB_VALUES.ISSUE_TYPE) {
      itemIds = tempBadgeData
        .map((item) => item?.issueTypeId)
        .filter((id) => id != null);
    } else if (activeTab === ACTIVE_TAB_VALUES.PRIORITY) {
      itemIds = tempBadgeData
        .map((item) => item?.priorityId)
        .filter((id) => id != null);
    } else if (activeTab === ACTIVE_TAB_VALUES.STATUS) {
      itemIds = tempBadgeData
        .map((item) => item?.statusId)
        .filter((id) => id != null);
    }

    // Build payload based on activeTab
    let payload;
    let saveApiCall;

    if (activeTab === ACTIVE_TAB_VALUES.ISSUE_TYPE) {
      payload = {
        configId: configId,
        priority: updatedSortNumvalue,
        categoryName: editedTitle,
        issueTypeIds: itemIds,
      };
      saveApiCall = dispatch(getJiraIssueTypeSave(payload));
    } else if (activeTab === ACTIVE_TAB_VALUES.PRIORITY) {
      payload = {
        configId: configId,
        priority: updatedSortNumvalue,
        categoryName: editedTitle,
        priorityIds: itemIds,
      };
      saveApiCall = dispatch(getJiraPrioritySave(payload));
    } else if (activeTab === ACTIVE_TAB_VALUES.STATUS) {
      payload = {
        configId: configId,
        priority: updatedSortNumvalue,
        categoryName: editedTitle,
        statusIds: itemIds,
      };
      saveApiCall = dispatch(getJiraStatusSave(payload));
    }

    saveApiCall.then((data) => {
      setSaveLoading(false);
      if (
        data.payload.statusCodeValue >= 200 &&
        data.payload.statusCodeValue < 300
      ) {
        callCommonAlert(
          "success",
          data.payload.body ? data.payload.body : "Updated Successfully"
        );
        setTimeout(() => {
          hideCommonAlert();
          cancelRemove();
          apiListData();
        }, 2000);
        setIsEditMode(false);
      } else if (data?.payload?.body) {
        callCommonAlert("error", data?.payload?.body);
        hideCommonAlert();
      } else if (data.error) {
        callCommonAlert(
          "error",
          "Error occurred while removing Please try again"
        );
        hideCommonAlert();
      }
    });

    setShowModal(false);
    setSelectedItem(null);
  };

  const handleAccordionToggle = () => {
    if (isEditMode && hasChanges) {
      setState((prev) => ({ ...prev, discardopen: true }));
      return;
    }

    setIsOpen(!isOpen);

    if (!isOpen) {
      setOriginalTitle(editedTitle);
      setOriginalOrder(updatedSortNumvalue);
      setOriginalBadgeData(badgeData);
    }
  };

  useEffect(() => {
    if (!isOpen) {
      setBadgeData(data); // reset to original data when accordion closes
    }
  }, [isOpen]);

  const confirmRemove = () => {
    if (selectedItem) {
      const updated = tempBadgeData.filter((option) => {
        const optionName = option?.name || option;
        return optionName !== selectedItem;
      });
      setTempBadgeData(updated); // Only update tempoary data
    }
    setShowModal(false);
    setSelectedItem(null);
  };

  const confirmCategoryDelete = () => {
    setDeleteLoading(true);

    // Find the current category from categorized data to get configId
    const currentCategory = Array.isArray(CatagorizedData)
      ? CatagorizedData.find((cat) => cat.categoryName === title)
      : null;

    const configId = currentCategory?.configId || null;

    const payload = {
      type: activeTab,
      configId: configId,
    };

    dispatch(deleteJiracategory(payload)).then((data) => {
      setDeleteLoading(false);
      if (
        data.payload.statusCodeValue >= 200 &&
        data.payload.statusCodeValue < 300
      ) {
        callCommonAlert(
          "success",
          data.payload.body ? data.payload.body : "Deleted Successfully"
        );
        setTimeout(() => {
          hideCommonAlert();
          cancelDelete();
          // Dispatch after popup closes
          apiListData();
        }, 2000); // 3 seconds
      } else if (data?.payload?.body) {
        callCommonAlert("error", data?.payload?.body);
        hideCommonAlert();
      } else if (data.error) {
        callCommonAlert(
          "error",
          "Error occurred while deleting. Please try again"
        );
        hideCommonAlert();
      }
    });

    setShowCategoryDeleteModal(false);
  };

  const Removemodal = () => {
    return (
      <>
        <>
          {saveLoading ? (
            <Spinners />
          ) : (
            <div>
              <p className="Mtop">
                Are you sure you want to remove <b>"{selectedItem}" </b>from{" "}
                <b>"{title}"</b> ?
              </p>
              <div
                className="btnswrap d-flex justify-content-center"
                style={{ gap: "5px" }}
              >
                <ButtonComponent
                  text="Cancel"
                  className={"cancelBtnStyle btn btn-primary"}
                  onClick={cancelRemove}
                />
                <ButtonComponent
                  text="Confirm"
                  className={"btnStyle btn btn-primary"}
                  onClick={confirmRemove}
                />
              </div>
            </div>
          )}
        </>
      </>
    );
  };

  const CategoryDeleteModal = () =>
    deleteLoading ? (
      <Spinners />
    ) : (
      <div>
        <p className="Mtop">
          Are you sure you want to delete the category <b>"{title}"</b>?
        </p>
        <div
          className="btnswrap d-flex justify-content-center"
          style={{ gap: "5px" }}
        >
          <ButtonComponent
            text="Cancel"
            className="cancelBtnStyle btn btn-primary"
            onClick={cancelDelete}
          />
          <ButtonComponent
            text="Delete"
            className="btnStyle btn btn-primary"
            onClick={confirmCategoryDelete}
          />
        </div>
      </div>
    );

  const handleIncrement = () => {
    const newValue = Number(updatedSortNumvalue) + 1;
    if (newValue <= sortingOrderLength) {
      setUpdateSortNumvalue(newValue.toString());
    }
  };

  const handleDecrement = () => {
    const newValue = Number(updatedSortNumvalue) - 1;
    if (newValue >= 1) {
      setUpdateSortNumvalue(newValue.toString());
    }
  };

  const hideDiscard = () => {
    setEditedTitle(originalTitle);
    setUpdateSortNumvalue(originalOrder);
    setTempBadgeData([...originalBadgeData]);
    setIsEditMode(false);
    setState((prev) => ({ ...prev, discardopen: false }));

    // If accordion was tried to be closed too
    if (isOpen) {
      setIsOpen(false);
    }
  };

  const closeDiscard = () => {
    setEditedTitle(originalTitle);
    setUpdateSortNumvalue(originalOrder);
    setTempBadgeData([...originalBadgeData]);
    setIsEditMode(false);
    setState((prev) => ({ ...prev, discardopen: false }));
  };

  const handleCloseDiscard = () => {
    setState((prev) => ({ ...prev, discardopen: false }));
  };

  const DiscardBody = () => {
    return (
      <>
        <DiscardChanges
          discardClick={hideDiscard}
          cancelClick={handleCloseDiscard}
        />
      </>
    );
  };

  return (
    <>
      {saveLoading || deleteLoading ? (
        <Spinners />
      ) : (
        <div
          className="container-fluid"
          onClick={(e) => {
            const isActionButton = e.target.closest(".clickable");
            if (!isActionButton && !isEditMode) {
              handleAccordionToggle();
              setIsEditMode(false);
            }
          }}
        >
          <div className="title-container">
            {/* Conditional rendering for title/edit mode */}
            {isEditMode && isUserAddedCategory(title) ? (
              <div className="d-flex">
                <Input
                  type="text"
                  value={editedTitle}
                  containerClassName={"frmgroup validate default-input col-4"}
                  onChange={(e) => setEditedTitle(e.target.value)}
                  // className="title-edit-input"
                  autoFocus
                />
                <Input
                  type="number"
                  min="1"
                  max={sortingOrderLength}
                  containerClassName={
                    "frmgroup validate default-input col-1 title-number-input"
                  }
                  placeholder="Number"
                  // inputClassName={" title-number-input"}
                  value={updatedSortNumvalue}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      const numericValue = Number(value);
                      if (numericValue <= sortingOrderLength) {
                        setUpdateSortNumvalue(value);
                      }
                    }
                  }}
                  // className="title-number-input"
                />
                <div className="arrow-icons">
                  <BiSolidUpArrow
                    className="arrow up"
                    onClick={handleDecrement}
                  />
                  <BiSolidDownArrow
                    className="arrow down"
                    onClick={handleIncrement}
                  />
                </div>
                {isEditMode && (
                  <span className="costomBadge primary costomBadgeAlign">
                    {itemCount} Items
                  </span>
                )}
              </div>
            ) : (
              <div className="title">{title}</div>
            )}

            <span>
              {isUserAddedCategory(title) ? (
                !isEditMode ? (
                  <FaLockOpen className="lock-icon" width={25} height={25} />
                ) : null
              ) : (
                <FaLock className="lock-icon" width={25} height={25} />
              )}
            </span>
            {!isEditMode ? (
              <span className="costomBadge primary">{itemCount} Items</span>
            ) : isUserAddedCategory(title) ? null : (
              <span className="costomBadge primary">{itemCount} Items</span>
            )}
            <span className="actions-right">
              <>
                {isOpen && (
                  <>
                    {/* Always show edit for user-added fields */}
                    {isUserAddedCategory(title) && (
                      <img
                        className="mx-2 clickable"
                        width={25}
                        height={25}
                        src={isEditMode ? AccordianEdit : AccordianEditDisable}
                        onClick={() => {
                          if (!isEditMode) {
                            handleEditClick();
                          } else {
                            setIsEditMode(false);
                          }
                        }}
                      />
                    )}

                    {/* Show edit only when items exist for default fields */}
                    {!isUserAddedCategory(title) && itemCount > 0 && (
                      <img
                        className="mx-2 clickable"
                        width={25}
                        height={25}
                        src={isEditMode ? AccordianEdit : AccordianEditDisable}
                        onClick={() => {
                          if (!isEditMode) {
                            handleEditClick();
                          } else {
                            setIsEditMode(false);
                          }
                        }}
                      />
                    )}
                  </>
                )}

                {isOpen && isUserAddedCategory(title) && (
                  <img
                    className="mx-2 clickable"
                    width={25}
                    height={25}
                    src={isDeleteMode ? AccordianDel : AccordianDelDisable}
                    onClick={() => {
                      if (badgeData.length > 0) {
                        callCommonAlert(
                          "error",
                          "Cannot delete the field with mapped Group"
                        );
                        hideCommonAlert();
                        return;
                      }
                      setIsDeleteMode(!isDeleteMode);
                      setShowCategoryDeleteModal(true);
                    }}
                  />
                )}
              </>
            </span>
            <span
              onClick={() => {
                handleAccordionToggle();
                setIsEditMode(false);
              }}
              className="accordion-icon"
            >
              <IoIosArrowDown
                className={`accordion-icon ${isOpen ? "open" : ""}`}
                size={25}
                color="grey"
              />
            </span>
          </div>
          {isOpen && (
            <div className="cat-border">
              <div className="costomBadge-container">
                {(isEditMode ? tempBadgeData : badgeData).map(
                  (option, index) => (
                    <Badge
                      key={index}
                      text={option?.name || option}
                      onRemove={handleRemoveClick}
                      showRemove={isEditMode}
                    />
                  )
                )}
              </div>

              {isEditMode && (
                <div className="edit-action-buttons">
                  <ButtonComponent
                    className="cancelBtnStyle btn btn-primary"
                    onClick={() => {
                      if (hasChanges) {
                        setState((prev) => ({ ...prev, discardopen: true }));
                      } else {
                        setEditedTitle(title);
                        setIsEditMode(false);
                        setTempBadgeData([...badgeData]);
                      }
                    }}
                    text={"Cancel"}
                  />
                  <ButtonComponent
                    className="btnStyle btn btn-primary"
                    onClick={saveForUpdating}
                    disabled={!hasChanges}
                    text={"Save"}
                  />
                </div>
              )}
            </div>
          )}

          <CustomModal
            modalOpen={showModal}
            modalBody={Removemodal}
            modalHide={cancelRemove}
            closeBtn={true}
            closeBtnFuc={cancelRemove}
            size={"md"}
          />

          <CustomModal
            modalOpen={showCategoryDeleteModal}
            modalBody={CategoryDeleteModal}
            modalHide={cancelDelete}
            closeBtn={true}
            closeBtnFuc={cancelDelete}
            size={"md"}
          />

          <CustomModal
            modalOpen={state.discardopen}
            modalBody={DiscardBody}
            modalHide={hideDiscard}
            closeBtn={true}
            closeBtnFuc={closeDiscard}
          />
        </div>
      )}{" "}
    </>
  );
};

export default CategorizedContainer;
